import WebIM from '../utils/webIM'
import config from '@/config'
import { getContacts, saveContact } from '@/api'

export default {
  async chatLogin({ getters, dispatch, commit, state }, payload) {
    if(getters.isLogin) {
      await dispatch('getConversationList')
    }
    var options = {
      apiUrl: WebIM.config.apiURL,
      user: payload.easemobAccount,
      pwd: payload.easemobPassword,
      appKey: WebIM.config.appkey,
      success: () => {
        // commit('setChatToken', res.access_token)
      },
    }
    if(state.isChatConnecting === 'linked') {
      WebIM.conn.mr_cache = []
      WebIM.conn.close()
    }
    commit('setChatConnecting', 'waiting')
    setTimeout(() => {
      WebIM.conn.open(options)
    }, 500)
  },

  chatLogout({ dispatch, commit }) {
    commit('setSendingUser', '')
    commit('clearAllChatData')
    dispatch('changeChatConnectStatus', false)
    WebIM.conn.close()
  },

  changeChatConnectStatus({ commit }, payload) {
    if (payload === true) {
      commit('setOnlineStatus', true)
      commit('setChatConnecting', 'linked')
    } else {
      commit('setOnlineStatus', false)
      commit('setChatConnecting', 'closed')
    }
  },

  // save new contact to server
  saveContact({ getters }, payload) {
    if(getters.isLogin) {
      saveContact(Object.assign({fromImUser: getters.imAccount.easemobAccount}, payload))
    }
  },

  getConversationList({ commit, getters }) {
    getContacts({
      fromImUser: getters.imAccount.easemobAccount,
      pageNum: 1,
      pageRows: 10000
    }).then(res => {
      commit('initChatData', res.data.data.list)
    })
  },

  async fetchChatMsg({ commit, state }) {
    const fetchMsgByID = function(id) {
      return new Promise(resolve => {
        const options = {
          queue: id.toLowerCase(),
          isGroup: false,
          count: config.chatFetchCount,
          success: res => {
            commit('setLoadMoreArr', { imAccount: id, value: res.length === config.chatFetchCount })
            commit('fillChatMsg', { imAccount: id, messages: res })
            resolve('success')
          },
          fail: () => {
            resolve('error')
          }
        }
        WebIM.conn.fetchHistoryMessages(options)
      })
    }

    const ids = Object.keys(state.allChatData)
    state.fetchImMsgStatus = false
    WebIM.conn.mr_cache = []
    for (let i = 0; i < ids.length; i++) {
      await fetchMsgByID(ids[i])
    }
    state.fetchImMsgStatus = true
    commit('syncUserList')
  },

  sendTxtMessage({ commit, getters, state }, payload) {
    const { chatType, chatId, sendingTxt, callback } = payload
    var id = WebIM.conn.getUniqueId() // 生成本地消息id
    var msg = new WebIM.message('txt', id) // 创建文本消息
    msg.set({
      msg: sendingTxt, // 消息内容
      to: chatId, // 接收消息对象（用户id）
      roomType: false,
      ext: {
        name: getters.info.userInfo.name,
        position: getters.info.userInfo.post,
        avatar: getters.info.userInfo.headImage,
        easemobAccount: getters.imAccount.easemobAccount,
        extendUserAvatar: getters.info.userInfo.headImage || '',
        extendUserNickName: getters.info.userInfo.name || '',
      },
      success: () => {
        commit('setChatList', {
          chatType,
          chatId,
          msg: sendingTxt,
          bySelf: true,
          time: new Date().getTime(),
          mid: id,
          status: 'sending',
          ext: state.receiver
        })
        callback()
      },
      fail: function() {
        // console.log('Send private text error')
      }
    })
    WebIM.conn.send(msg.body)
  },

  sendImgMessage({ commit, getters, state }, payload) {
    const { chatType, chatId, roomType, file } = payload
    const id = WebIM.conn.getUniqueId()

    const msgObj = new WebIM.message('img', id)
    msgObj.set({
      apiUrl: WebIM.config.apiURL,
      file: file,
      to: chatId,
      roomType: roomType,
      ext: {
        name: getters.info.userInfo.name,
        position: getters.info.userInfo.post,
        avatar: getters.info.userInfo.headImage,
        easemobAccount: getters.imAccount.easemobAccount,
        extendUserAvatar: getters.info.userInfo.headImage || '',
        extendUserNickName: getters.info.userInfo.name || '',
      },
      onFileUploadError: function() {
        // console.log('图片上传失败', error)
      },
      onFileUploadComplete: function(data) {
        let url = data.uri + '/' + data.entities[0].uuid
        commit('setChatList', {
          msg: url,
          chatType,
          chatId: chatId,
          bySelf: true,
          type: 'img',
          time: data.timestamp,
          mid: id,
          status: 'sending',
          ext: state.receiver
        })
      },
      success: function() {
        // console.log('图片发送成功')
      }
    })

    WebIM.conn.send(msgObj.body)
  },

  sendFileMessage({ commit, getters, state }, payload) {
    const { chatType, chatId, roomType, file } = payload
    const id = WebIM.conn.getUniqueId()

    const msgObj = new WebIM.message('file', id)
    msgObj.set({
      apiUrl: WebIM.config.apiURL,
      file: file,
      ext: {
        name: getters.info.userInfo.name,
        position: getters.info.userInfo.post,
        avatar: getters.info.userInfo.headImage,
        easemobAccount: getters.imAccount.easemobAccount,
        file_length: file.data.size,
        extendUserAvatar: getters.info.userInfo.headImage || '',
        extendUserNickName: getters.info.userInfo.name || '',
      },
      to: chatId,
      roomType: roomType,
      onFileUploadError: function() {
        // console.log('文件上传失败', error)
      },
      onFileUploadComplete: function(data) {
        let url = data.uri + '/' + data.entities[0].uuid
        commit('setChatList', {
          msg: url,
          chatType,
          chatId: chatId,
          bySelf: true,
          type: 'file',
          filename: file.data.name,
          file_length: file.data.size,
          time: data.timestamp,
          mid: id,
          status: 'sending',
          ext: state.receiver
        })
      },
      success: function() {
        // console.log('文件发送成功')
      }
    })

    WebIM.conn.send(msgObj.body)
  }
}
